export const Types = {
  START_USER_TYPES_FIND: 'START_USER_TYPES_FIND',
  END_USER_TYPES_FIND: 'END_USER_TYPES_FIND',

  START_USER_ROLES_FIND: 'START_USER_ROLES_FIND',
  END_USER_ROLES_FIND: 'END_USER_ROLES_FIND',
};
